import { $FixMe } from '@eventbrite/ts-utils';
import loadable from '@loadable/component';
import React, { useEffect, useState } from 'react';

const LazyInlineDatePicker: $FixMe = (props: JSX.IntrinsicAttributes) => {
    const [LazyComponent, setLazyComponent] = useState<$FixMe>(null);

    useEffect(() => {
        if (!LazyComponent) {
            const LazyLoadedComponent = loadable(
                () => import('./InlineDatePicker'),
                {
                    fallback: <div />,
                },
            );

            setLazyComponent(LazyLoadedComponent);
        }
    }, [LazyComponent]);

    return LazyComponent ? <LazyComponent {...props} /> : null;
};

export default LazyInlineDatePicker;
